import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import { DBIntFieldObjective, DBDropDown, DBTextArea, ToolTipBulb } from '_components';
import styles from './MaterialHandling.module.css';
import { noteActions } from '_actions';

class PatientCareCenterNoteObjectiveMaterialHandling extends React.Component {

    renderToolTip() {
        return (
            <div className={styles.tooltip}>
                <ToolTipBulb uid={'Material_Handling'} position='left' width={680} size='small'>
                    <div className={styles.tooltipContainer}>
                        <div className={styles.tooltipGrid}>
                            <div className={styles.tooltipRow}>
                                <div className={`${styles.tooltipCell} ${styles.headerCell}`}>Physical Demand Level</div>
                                <div className={`${styles.tooltipCell} ${styles.headerCell}`}>Occasional
                                    <div className={styles.grid_body_label}> % of Time: 0%-33%<br />~Reps 1-100<br />1 Rep every 15 min</div>
                                </div>
                                <div className={`${styles.tooltipCell} ${styles.headerCell}`}>Frequent
                                    <div className={styles.grid_body_label}> % of Time: 34%-66%<br />~Reps 100-500<br />1 Rep every 5 min</div>
                                </div>
                                <div className={`${styles.tooltipCell} ${styles.headerCell}`}>Constant
                                    <div className={styles.grid_body_label}> % of Time: 67%-100%<br />~Reps 500+<br />&gt;1 Rep every 5 min</div>
                                </div>
                            </div>


                            <div className={styles.tooltipRow}>
                                <div className={`${styles.tooltipCell} ${styles.headerCell}`}>Sedentary</div>
                                <div className={`${styles.tooltipCell} ${styles.headerCell}`}>0-10 lbs.</div>
                                <div className={`${styles.tooltipCell} ${styles.headerCell}`}>Negligible</div>
                                <div className={`${styles.tooltipCell} ${styles.headerCell}`}>Negligible</div>
                            </div>

                            <div className={styles.tooltipRow}>
                                <div className={`${styles.tooltipCell} ${styles.headerCell}`}>Light</div>
                                <div className={`${styles.tooltipCell} ${styles.headerCell}`}>0-20 lbs.</div>
                                <div className={`${styles.tooltipCell} ${styles.headerCell}`}>10 lbs.
                                    <div className={styles.grid_body_label}>walk/stand and/or push/pull of arm/leg controls</div>
                                </div>
                                <div className={`${styles.tooltipCell} ${styles.headerCell}`}>Negligible
                                    <div className={styles.grid_body_label}>Push/pull of arm/leg controls while sitting</div>
                                </div>
                            </div>

                            <div className={styles.tooltipRow}>
                                <div className={`${styles.tooltipCell} ${styles.headerCell}`}>Medium</div>
                                <div className={`${styles.tooltipCell} ${styles.headerCell}`}>21-50 lbs.</div>
                                <div className={`${styles.tooltipCell} ${styles.headerCell}`}>25 lbs.</div>
                                <div className={`${styles.tooltipCell} ${styles.headerCell}`}>10 lbs.</div>
                            </div>

                            <div className={styles.tooltipRow}>
                                <div className={`${styles.tooltipCell} ${styles.headerCell}`}>Heavy</div>
                                <div className={`${styles.tooltipCell} ${styles.headerCell}`}>51-100 lbs.</div>
                                <div className={`${styles.tooltipCell} ${styles.headerCell}`}>50 lbs.</div>
                                <div className={`${styles.tooltipCell} ${styles.headerCell}`}>20 lbs.</div>
                            </div>

                            <div className={styles.tooltipRow}>
                                <div className={`${styles.tooltipCell} ${styles.headerCell}`}>Very Heavy</div>
                                <div className={`${styles.tooltipCell} ${styles.headerCell}`}>Over 100 lbs.</div>
                                <div className={`${styles.tooltipCell} ${styles.headerCell}`}>Over 50 lbs.</div>
                                <div className={`${styles.tooltipCell} ${styles.headerCell}`}>Over 20 lbs.</div>
                            </div>
                        </div>
                    </div>
                </ToolTipBulb>
            </div>
        );
    }

    render() {
        let options = [
            { id: 'Occasional', value: 'Occasional' },
            { id: 'Frequent', value: 'Frequent' },
            { id: 'Constant', value: 'Constant' },
            { id: 'N/A', value: 'N/A' },
            { id: 'N/T', value: 'N/T' }
        ];
        let todayMeasurementsOptions = [
            { id: 'Occasional', value: 'Occasional' },
            { id: 'Frequent', value: 'Frequent' },
            { id: 'Constant', value: 'Constant' },
            { id: 'N/A', value: 'N/A' },
            { id: 'N/T', value: 'N/T' },
            { id: 'Unable', value: 'Unable' }
        ];
        return (
            <PatientCareCenterNoteSection id='obj_materialHandling' name='Material Handling' refProp={this.props.refProp} level={5} showToolTip toolTip={this.renderToolTip}>
                <div className={styles.row}>
                    <label className={styles.col1}><strong>Client can lift:</strong></label>
                    <label className={styles.col2}><strong>Job Requirement</strong></label>
                    <label className={styles.col3}><strong>Today's Measurements</strong></label>
                </div>
                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label className={this.props.noteType === 2 || this.props.noteType === 4 || (this.props.jobLbs && this.props.jobTxt && this.props.curLbs && this.props.curTxt) ? '' : styles.label_req}>Floor to waist</label>
                    </div>

                    <div className={styles.col2_row}>

                        <DBIntFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHFLTOWAJOBLBS'
                            className={styles.field}
                            min={0}
                        />
                        <label className={styles.label}>lbs.</label>
                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHFLTOWAJOBTXT'
                            customOptions={options}
                        />
                    </div>

                    <div className={styles.col3_row}>
                        <DBIntFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHFLTOWACURLBS'
                            className={styles.field}
                            min={0}
                        />

                        <label className={styles.label}>lbs.</label>
                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHFLTOWACURTXT'
                            customOptions={todayMeasurementsOptions}
                        />
                        <span className={styles.prev_wrapper}>
                            {this.props.prevFloorToWaistCurLbs && `${this.props.prevFloorToWaistCurLbs} lbs`}
                        </span>
                        <span className={styles.prev_wrapper}>
                            {this.props.prevFloorToWaistCurTxt}
                        </span>
                    </div>
                </div>

                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>(R) Unilateral Floor to Waist</label>
                    </div>

                    <div className={styles.col2_row}>

                        <DBIntFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHFLTOWARUJOBLBS'
                            className={styles.field}
                            min={0}
                        />
                        <label className={styles.label}>lbs.</label>
                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHFLTOWARUJOBTXT'
                            customOptions={options}
                        />
                    </div>

                    <div className={styles.col3_row}>
                        <DBIntFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHFLTOWARUCURLBS'
                            className={styles.field}
                            min={0}
                        />

                        <label className={styles.label}>lbs.</label>
                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHFLTOWARUCURTXT'
                            customOptions={todayMeasurementsOptions}
                        />
                        <span className={styles.prev_wrapper}>
                            {this.props.prevRFloorLbs && `${this.props.prevRFloorLbs} lbs`}
                        </span>
                        <span className={styles.prev_wrapper}>
                            {this.props.prevRFloorTxt}
                        </span>
                    </div>
                </div>

                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>(L) Unilateral Floor to Waist</label>
                    </div>

                    <div className={styles.col2_row}>

                        <DBIntFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHFLTOWALUJOBLBS'
                            className={styles.field}
                            min={0}
                        />
                        <label className={styles.label}>lbs.</label>
                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHFLTOWALUJOBTXT'
                            customOptions={options}
                        />
                    </div>

                    <div className={styles.col3_row}>
                        <DBIntFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHFLTOWALUCURLBS'
                            className={styles.field}
                            min={0}
                        />

                        <label className={styles.label}>lbs.</label>
                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHFLTOWALUCURTXT'
                            customOptions={todayMeasurementsOptions}
                        />
                        <span className={styles.prev_wrapper}>
                            {this.props.prevLFloorLbs && `${this.props.prevLFloorLbs} lbs`}
                        </span>
                        <span className={styles.prev_wrapper}>
                            {this.props.prevLFloorTxt}
                        </span>
                    </div>
                </div>

                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label className={this.props.noteType === 2 || this.props.noteType === 4 || (this.props.shoulderJobLbs && this.props.shoulderJobTxt && this.props.shoulderCurLbs && this.props.shoulderCurTxt) ? '' : styles.label_req}>Waist to shoulder</label>
                    </div>

                    <div className={styles.col2_row}>

                        <DBIntFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHWATOSHJOBLBS'
                            className={styles.field}
                            min={0}
                        />
                        <label className={styles.label}>lbs.</label>
                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHWATOSHJOBTXT'
                            customOptions={options}
                        />
                    </div>

                    <div className={styles.col3_row}>
                        <DBIntFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHWATOSHCURLBS'
                            className={styles.field}
                            min={0}
                        />

                        <label className={styles.label}>lbs.</label>
                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHWATOSHCURTXT'
                            customOptions={todayMeasurementsOptions}
                        />
                        <span className={styles.prev_wrapper}>
                            {this.props.prevWaistToShoulderCurLbs && `${this.props.prevWaistToShoulderCurLbs} lbs`}
                        </span>
                        <span className={styles.prev_wrapper}>
                            {this.props.prevWaistToShoulderCurTxt}
                        </span>
                    </div>
                </div>

                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>Waist to Overhead</label>
                    </div>

                    <div className={styles.col2_row}>

                        <DBIntFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHOVERJOBLBS'
                            className={styles.field}
                            min={0}
                        />
                        <label className={styles.label}>lbs.</label>
                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHOVERJOBTXT'
                            customOptions={options}
                        />
                    </div>

                    <div className={styles.col3_row}>
                        <DBIntFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHOVERCURLBS'
                            className={styles.field}
                            min={0}
                        />

                        <label className={styles.label}>lbs.</label>
                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHOVERCURTXT'
                            customOptions={todayMeasurementsOptions}
                        />
                        <span className={styles.prev_wrapper}>
                            {this.props.prevOverheadCurLbs && `${this.props.prevOverheadCurLbs} lbs`}
                        </span>
                        <span className={styles.prev_wrapper}>
                            {this.props.prevOverheadCurTxt}
                        </span>
                    </div>
                </div>

                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>(R) Unilateral Waist to Overhead</label>
                    </div>

                    <div className={styles.col2_row}>

                        <DBIntFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHOVERRUJOBLBS'
                            className={styles.field}
                            min={0}
                        />
                        <label className={styles.label}>lbs.</label>
                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHOVERRUJOBTXT'
                            customOptions={options}
                        />
                    </div>

                    <div className={styles.col3_row}>
                        <DBIntFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHOVERRUCURLBS'
                            className={styles.field}
                            min={0}
                        />

                        <label className={styles.label}>lbs.</label>
                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHOVERRUCURTXT'
                            customOptions={todayMeasurementsOptions}
                        />
                        <span className={styles.prev_wrapper}>
                            {this.props.prevROverheadLbs && `${this.props.prevROverheadLbs} lbs`}
                        </span>
                        <span className={styles.prev_wrapper}>
                            {this.props.prevROverheadTxt}
                        </span>
                    </div>
                </div>

                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>(L) Unilateral Waist to Overhead</label>
                    </div>

                    <div className={styles.col2_row}>

                        <DBIntFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHOVERLUJOBLBS'
                            className={styles.field}
                            min={0}
                        />
                        <label className={styles.label}>lbs.</label>
                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHOVERLUJOBTXT'
                            customOptions={options}
                        />
                    </div>

                    <div className={styles.col3_row}>
                        <DBIntFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHOVERLUCURLBS'
                            className={styles.field}
                            min={0}
                        />

                        <label className={styles.label}>lbs.</label>
                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHOVERLUCURTXT'
                            customOptions={todayMeasurementsOptions}
                        />
                        <span className={styles.prev_wrapper}>
                            {this.props.prevLOverheadLbs && `${this.props.prevLOverheadLbs} lbs`}
                        </span>
                        <span className={styles.prev_wrapper}>
                            {this.props.prevLOverheadTxt}
                        </span>
                    </div>
                </div>


                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label className={this.props.noteType === 2 || this.props.noteType === 4 || (this.props.carryJobLbs && this.props.carryJobTxt && this.props.carryCurLbs && this.props.carryCurTxt) ? '' : styles.label_req}>Carry</label>
                    </div>
                    <div className={styles.col2_row}>

                        <DBIntFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHCARRYJOBLBS'
                            className={styles.field}
                            min={0}
                        />
                        <label className={styles.label}>lbs.</label>
                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHCARRYJOBTXT'
                            customOptions={options}
                        />
                    </div>

                    <div className={styles.col3_row}>
                        <DBIntFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHCARRYCURLBS'
                            className={styles.field}
                            min={0}
                        />

                        <label className={styles.label}>lbs.</label>
                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHCARRYCURTXT'
                            customOptions={todayMeasurementsOptions}
                        />
                        <span className={styles.prev_wrapper}>
                            {this.props.prevCarryCurLbs && `${this.props.prevCarryCurLbs} lbs`}
                        </span>
                        <span className={styles.prev_wrapper}>
                            {this.props.prevCarryCurTxt}
                        </span>
                    </div>
                </div>

                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>(R) Unilateral Carry</label>
                    </div>

                    <div className={styles.col2_row}>

                        <DBIntFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHCARRYRUJOBLBS'
                            className={styles.field}
                            min={0}
                        />
                        <label className={styles.label}>lbs.</label>
                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHCARRYRUJOBTXT'
                            customOptions={options}
                        />
                    </div>

                    <div className={styles.col3_row}>
                        <DBIntFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHCARRYRUCURLBS'
                            className={styles.field}
                            min={0}
                        />

                        <label className={styles.label}>lbs.</label>
                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHCARRYRUCURTXT'
                            customOptions={todayMeasurementsOptions}
                        />
                        <span className={styles.prev_wrapper}>
                            {this.props.prevRCarryLbs && `${this.props.prevRCarryLbs} lbs`}
                        </span>
                        <span className={styles.prev_wrapper}>
                            {this.props.prevRCarryTxt}
                        </span>
                    </div>
                </div>

                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>(L) Unilateral Carry</label>
                    </div>

                    <div className={styles.col2_row}>

                        <DBIntFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHCARRYLUJOBLBS'
                            className={styles.field}
                            min={0}
                        />
                        <label className={styles.label}>lbs.</label>
                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHCARRYLUJOBTXT'
                            customOptions={options}
                        />
                    </div>

                    <div className={styles.col3_row}>
                        <DBIntFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHCARRYLUCURLBS'
                            className={styles.field}
                            min={0}
                        />

                        <label className={styles.label}>lbs.</label>
                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHCARRYLUCURTXT'
                            customOptions={todayMeasurementsOptions}
                        />
                        <span className={styles.prev_wrapper}>
                            {this.props.prevLCarryLbs && `${this.props.prevLCarryLbs} lbs`}
                        </span>
                        <span className={styles.prev_wrapper}>
                            {this.props.prevLCarryTxt}
                        </span>
                    </div>
                </div>

                <div className={styles.row}>

                    <div className={styles.col1_row}>
                        <label>Push</label>
                    </div>
                    <div className={styles.col2_row}>

                        <DBIntFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHPUSHJOBLBS'
                            className={styles.field}
                            min={0}
                        />
                        <label className={styles.label}>lbs.</label>
                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHPUSHJOBTXT'
                            customOptions={options}
                        />
                    </div>

                    <div className={styles.col3_row}>
                        <DBIntFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHPUSHCURLBS'
                            className={styles.field}
                            min={0}
                        />

                        <label className={styles.label}>lbs.</label>
                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHPUSHCURTXT'
                            customOptions={todayMeasurementsOptions}
                        />
                        <span className={styles.prev_wrapper}>
                            {this.props.prevPushCurLbs && `${this.props.prevPushCurLbs} lbs`}
                        </span>
                        <span className={styles.prev_wrapper}>
                            {this.props.prevPushCurTxt}
                        </span>
                    </div>
                </div>

                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>Pull</label>
                    </div>
                    <div className={styles.col2_row}>

                        <DBIntFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHPULLJOBLBS'
                            className={styles.field}
                            min={0}
                        />
                        <label className={styles.label}>lbs.</label>
                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHPULLJOBTXT'
                            customOptions={options}
                        />
                    </div>

                    <div className={styles.col3_row}>
                        <DBIntFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHPULLCURLBS'
                            className={styles.field}
                            min={0}
                        />

                        <label className={styles.label}>lbs.</label>
                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEMATHAND'
                            entityKeyColumn='MHNO'
                            entityKeyValue={this.props.mhno}
                            field='MHPULLCURTXT'
                            customOptions={todayMeasurementsOptions}
                        />
                        <span className={styles.prev_wrapper}>
                            {this.props.prevPullCurLbs && `${this.props.prevPullCurLbs} lbs`}
                        </span>
                        <span className={styles.prev_wrapper}>
                            {this.props.prevPullCurTxt}
                        </span>
                    </div>
                </div>

                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label><strong>Comments</strong></label>
                    </div>
                </div>


                <DBTextArea
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVEMATHAND'
                    entityKeyColumn='MHNO'
                    entityKeyValue={this.props.mhno}
                    field='MHCOMMENTS'
                    className={styles.textarea}
                />
                <span className={styles.prev_comments_wrapper}>
                    {this.props.prevComments}
                </span>


            </PatientCareCenterNoteSection>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateTextField: bindActionCreators(noteActions.updateTextField, dispatch),
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let mhno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEMATHAND)
        .find(key => (state.entities.notes.PTOBJECTIVEMATHAND[key].MHEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEMATHAND[key].MHNTNO === pk && noteType !== 1)));

    // Get previous values
    let prevFloorToWaistCurLbs = '';
    let prevFloorToWaistCurTxt = '';
    let prevWaistToShoulderCurLbs = '';
    let prevWaistToShoulderCurTxt = '';
    let prevOverheadCurLbs = '';
    let prevOverheadCurTxt = '';
    let prevCarryCurLbs = '';
    let prevCarryCurTxt = '';
    let prevPushCurLbs = '';
    let prevPushCurTxt = '';
    let prevPullCurLbs = '';
    let prevPullCurTxt = '';
    let prevComments = '';

    let prevRFloorLbs = '';
    let prevRFloorTxt = '';
    let prevLFloorLbs = '';
    let prevLFloorTxt = '';
    let prevROverheadLbs = '';
    let prevROverheadTxt = '';
    let prevLOverheadLbs = '';
    let prevLOverheadTxt = '';
    let prevRCarryLbs = '';
    let prevRCarryTxt = '';
    let prevLCarryLbs = '';
    let prevLCarryTxt = '';

    if (noteType !== 1 && state.entities.notes.PTOBJECTIVEMATHANDPREV[pk]) {
        prevFloorToWaistCurLbs = state.entities.notes.PTOBJECTIVEMATHANDPREV[pk]['MHFLTOWACURLBS'];
        prevFloorToWaistCurTxt = state.entities.notes.PTOBJECTIVEMATHANDPREV[pk]['MHFLTOWACURTXT'];
        prevWaistToShoulderCurLbs = state.entities.notes.PTOBJECTIVEMATHANDPREV[pk]['MHWATOSHCURLBS'];
        prevWaistToShoulderCurTxt = state.entities.notes.PTOBJECTIVEMATHANDPREV[pk]['MHWATOSHCURTXT'];
        prevOverheadCurLbs = state.entities.notes.PTOBJECTIVEMATHANDPREV[pk]['MHOVERCURLBS'];
        prevOverheadCurTxt = state.entities.notes.PTOBJECTIVEMATHANDPREV[pk]['MHOVERCURTXT'];
        prevCarryCurLbs = state.entities.notes.PTOBJECTIVEMATHANDPREV[pk]['MHCARRYCURLBS'];
        prevCarryCurTxt = state.entities.notes.PTOBJECTIVEMATHANDPREV[pk]['MHCARRYCURTXT'];
        prevPushCurLbs = state.entities.notes.PTOBJECTIVEMATHANDPREV[pk]['MHPUSHCURLBS'];
        prevPushCurTxt = state.entities.notes.PTOBJECTIVEMATHANDPREV[pk]['MHPUSHCURTXT'];
        prevPullCurLbs = state.entities.notes.PTOBJECTIVEMATHANDPREV[pk]['MHPULLCURLBS'];
        prevPullCurTxt = state.entities.notes.PTOBJECTIVEMATHANDPREV[pk]['MHPULLCURTXT'];
        prevComments = state.entities.notes.PTOBJECTIVEMATHANDPREV[pk]['MHCOMMENTS'];

        prevRFloorLbs = state.entities.notes.PTOBJECTIVEMATHANDPREV[pk]['MHFLTOWARUCURLBS'];
        prevRFloorTxt = state.entities.notes.PTOBJECTIVEMATHANDPREV[pk]['MHFLTOWARUCURTXT'];
        prevLFloorLbs = state.entities.notes.PTOBJECTIVEMATHANDPREV[pk]['MHFLTOWALUCURLBS'];
        prevLFloorTxt = state.entities.notes.PTOBJECTIVEMATHANDPREV[pk]['MHFLTOWALUCURTXT'];
        prevROverheadLbs = state.entities.notes.PTOBJECTIVEMATHANDPREV[pk]['MHOVERRUCURLBS'];
        prevROverheadTxt = state.entities.notes.PTOBJECTIVEMATHANDPREV[pk]['MHOVERRUCURTXT'];
        prevLOverheadLbs = state.entities.notes.PTOBJECTIVEMATHANDPREV[pk]['MHOVERLUCURLBS'];
        prevLOverheadTxt = state.entities.notes.PTOBJECTIVEMATHANDPREV[pk]['MHOVERLUCURTXT'];
        prevRCarryLbs = state.entities.notes.PTOBJECTIVEMATHANDPREV[pk]['MHCARRYRUCURLBS'];
        prevRCarryTxt = state.entities.notes.PTOBJECTIVEMATHANDPREV[pk]['MHCARRYRUCURTXT'];
        prevLCarryLbs = state.entities.notes.PTOBJECTIVEMATHANDPREV[pk]['MHCARRYLUCURLBS'];
        prevLCarryTxt = state.entities.notes.PTOBJECTIVEMATHANDPREV[pk]['MHCARRYLUCURTXT'];
    }


    return {
        noteId,
        noteType,
        mhno,
        jobLbs: state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHFLTOWAJOBLBS'] !== undefined
            && state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHFLTOWAJOBLBS'] !== null,
        jobTxt: state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHFLTOWAJOBTXT'] !== undefined
            && state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHFLTOWAJOBTXT'] !== null,
        curLbs: state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHFLTOWACURLBS'] !== undefined
            && state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHFLTOWACURLBS'] !== null,
        curTxt: state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHFLTOWACURTXT'] !== undefined
            && state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHFLTOWACURTXT'] !== null,

        shoulderJobLbs: state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHWATOSHJOBLBS'] !== undefined
            && state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHWATOSHJOBLBS'] !== null,
        shoulderJobTxt: state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHWATOSHJOBTXT'] !== undefined
            && state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHWATOSHJOBTXT'] !== null,
        shoulderCurLbs: state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHWATOSHCURLBS'] !== undefined
            && state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHWATOSHCURLBS'] !== null,
        shoulderCurTxt: state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHWATOSHCURTXT'] !== undefined
            && state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHWATOSHCURTXT'] !== null,

        overheadJobLbs: state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHOVERJOBLBS'] !== undefined
            && state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHOVERJOBLBS'] !== null,
        overheadJobTxt: state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHOVERJOBTXT'] !== undefined
            && state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHOVERJOBTXT'] !== null,
        overheadCurLbs: state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHOVERCURLBS'] !== undefined
            && state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHOVERCURLBS'] !== null,
        overheadCurTxt: state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHOVERCURTXT'] !== undefined
            && state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHOVERCURTXT'] !== null,

        carryJobLbs: state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHCARRYJOBLBS'] !== undefined
            && state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHCARRYJOBLBS'] !== null,
        carryJobTxt: state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHCARRYJOBTXT'] !== undefined
            && state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHCARRYJOBTXT'] !== null,
        carryCurLbs: state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHCARRYCURLBS'] !== undefined
            && state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHCARRYCURLBS'] !== null,
        carryCurTxt: state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHCARRYCURTXT'] !== undefined
            && state.entities.notes['PTOBJECTIVEMATHAND'][mhno]['MHCARRYCURTXT'] !== null,

        // Previous values
        prevFloorToWaistCurLbs,
        prevFloorToWaistCurTxt,
        prevWaistToShoulderCurLbs,
        prevWaistToShoulderCurTxt,
        prevOverheadCurLbs,
        prevOverheadCurTxt,
        prevCarryCurLbs,
        prevCarryCurTxt,
        prevPushCurLbs,
        prevPushCurTxt,
        prevPullCurLbs,
        prevPullCurTxt,
        prevComments,
        prevRFloorLbs,
        prevRFloorTxt,
        prevLFloorLbs,
        prevLFloorTxt,
        prevROverheadLbs,
        prevROverheadTxt,
        prevLOverheadLbs,
        prevLOverheadTxt,
        prevRCarryLbs,
        prevRCarryTxt,
        prevLCarryLbs,
        prevLCarryTxt
    };
}

const connectedPatientCareCenterNoteObjectiveMaterialHandling = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteObjectiveMaterialHandling);
export { connectedPatientCareCenterNoteObjectiveMaterialHandling as PatientCareCenterNoteObjectiveMaterialHandling };

